document.addEventListener('DOMContentLoaded', function() {
  // Находим все блоки "Show more bouquets"
  const loadMoreCards = document.querySelectorAll('.more-card');

  loadMoreCards.forEach((card, cardIndex) => {
      // Находим родительский блок с товарами
      const collectionBlock = card.closest('.featured-collection-section') || 
                            card.closest('.featured-collection') || 
                            card.closest('.container').parentElement;
      
      // Пропускаем блоки с классом bestsellers
      if (collectionBlock.classList.contains('bestsellers')) {
          return;
      }
      
      // Находим все карточки товаров в этом блоке (исключая сам more-card)
      const productItems = collectionBlock.querySelectorAll('.product__grid-item:not(.more-card)');
      const itemsToShow = 3;
      
      // Пропускаем если товаров мало
      if (productItems.length <= itemsToShow) {
          card.style.display = 'none';
          return;
      }
      
      // Обновляем счетчик в блоке
      const hiddenCount = productItems.length - itemsToShow;
      const countElement = card.querySelector('.title__count');
      if (countElement) {
          countElement.textContent = hiddenCount;
      }
      
      // Создаем уникальный класс для скрытых товаров
      const hiddenClass = `hidden-products-${cardIndex}`;
      
      // Полностью скрываем товары кроме первых N
      productItems.forEach((item, index) => {
          if (index >= itemsToShow) {
              item.classList.add('hidden-product-item', hiddenClass);
          }
      });
      
      // Обработчик клика на карточку
      card.addEventListener('click', function() {
          const hiddenItems = collectionBlock.querySelectorAll(`.${hiddenClass}`);
          
          // Показываем все скрытые товары сразу
          hiddenItems.forEach((item) => {
              item.classList.remove('hidden-product-item');
          });
          
          // Сразу скрываем карточку
          this.setAttribute('style', 'display: none !important');
      });
      
      // Добавляем курсор pointer для интерактивности
      card.style.cursor = 'pointer';
  });
});
